import React from 'react';
import { Box, Typography, TextField, InputAdornment, List, ListItem, ListItemText, Divider, Link as MuiLink } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import DescriptionIcon from '@mui/icons-material/Description';
import { Link } from 'react-router-dom';
import { blogPosts } from '../data/blogData';

const BlogSidebar = () => {
    // Get recent posts (limit to 5)
    const recentPosts = blogPosts.slice(0, 5);

    const archives = [
        'January 2020', 'December 2019', 'March 2018', 'August 2017', 'June 2017',
        'December 2016', 'November 2016', 'September 2016', 'August 2016',
        'June 2016', 'March 2016', 'January 2016', 'May 2013'
    ];

    const categories = [
        'BPO', 'Loyalty', 'Uncategorized'
    ];

    return (
        <Box sx={{ pl: { md: 4 }, py: 2 }}>
            {/* Search */}
            <Box sx={{ mb: 4, display: 'flex' }}>
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Search"
                    size="small"
                    InputProps={{
                        sx: {
                            borderRadius: 0,
                            bgcolor: '#f5f5f5',
                            fontSize: '13px',
                            '& .MuiOutlinedInput-notchedOutline': { border: 'none' }
                        }
                    }}
                />
                <Box sx={{ bgcolor: '#87CEEB', display: 'flex', alignItems: 'center', justifyContent: 'center', width: 40, cursor: 'pointer' }}>
                    <SearchIcon sx={{ color: '#fff', fontSize: '20px' }} />
                </Box>
            </Box>

            {/* Recent Posts */}
            <Box sx={{ mb: 4 }}>
                <Typography variant="h6" sx={{ fontSize: '14px', fontWeight: 'bold', mb: 1, color: '#333' }}>
                    Recent Posts
                </Typography>
                <Divider sx={{ mb: 2, width: '30px', borderBottomWidth: 3, borderColor: '#87CEEB' }} /> {/* Thicker underline */}
                <List disablePadding>
                    {recentPosts.map((post, index) => (
                        <ListItem key={post.id} disablePadding sx={{ mb: 2, alignItems: 'flex-start', borderBottom: index < recentPosts.length - 1 ? '1px solid #eee' : 'none', pb: index < recentPosts.length - 1 ? 2 : 0 }}>
                            <Box sx={{ width: 50, height: 50, mr: 2, flexShrink: 0, bgcolor: '#f5f5f5' }}>
                                {post.imageUrl && post.id !== 3 ? (
                                    <img src={post.imageUrl} alt={post.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={(e) => { e.target.style.display = 'none'; e.target.parentElement.style.backgroundColor = '#87CEEB'; }} />
                                ) : (
                                    <Box sx={{ width: '100%', height: '100%', bgcolor: '#87CEEB', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <DescriptionIcon sx={{ color: '#fff', fontSize: '24px' }} />
                                    </Box>
                                )}
                            </Box>
                            <Link to={`/news-and-updates/${post.slug}`} style={{ textDecoration: 'none', color: '#666', fontSize: '13px', lineHeight: 1.4, display: 'flex', alignItems: 'center', height: '100%' }}>
                                <Typography sx={{ fontSize: '13px', color: '#666', lineHeight: 1.4, '&:hover': { color: '#007bff' } }}>
                                    {post.title}
                                </Typography>
                            </Link>
                        </ListItem>
                    ))}
                </List>
            </Box>

            {/* Archives */}
            <Box sx={{ mb: 4 }}>
                <Typography variant="h6" sx={{ fontSize: '18px', fontWeight: 'bold', mb: 2, borderLeft: '4px solid #007bff', pl: 2, color: '#333' }}>
                    Archives
                </Typography>
                <List disablePadding>
                    {archives.map((archive) => (
                        <ListItem key={archive} disablePadding sx={{ mb: 1, display: 'block' }}>
                            <Typography sx={{ fontSize: '14px', color: '#666' }}>{archive}</Typography>
                        </ListItem>
                    ))}
                </List>
            </Box>

            {/* Categories */}
            <Box sx={{ mb: 4 }}>
                <Typography variant="h6" sx={{ fontSize: '18px', fontWeight: 'bold', mb: 2, borderLeft: '4px solid #007bff', pl: 2, color: '#333' }}>
                    Categories
                </Typography>
                <List disablePadding>
                    {categories.map((category) => (
                        <ListItem key={category} disablePadding sx={{ mb: 1, display: 'block' }}>
                            <Typography sx={{ fontSize: '14px', color: '#666' }}>{category}</Typography>
                        </ListItem>
                    ))}
                </List>
            </Box>

        </Box>
    );
};

export default BlogSidebar;
